export function SpinningToken() {
  return (
    <div className="hx-ui pointer-events-none absolute right-4 top-24 z-20 sm:right-8 sm:top-28" data-testid="home-sanity-token" aria-label="Selvix Token" role="img">
      <div className="token-stage">
        <div className="token-coin">
          <img src="/brand/selvix-token.webp" alt="" className="token-face" draggable={false} />
          <img src="/brand/selvix-token.webp" alt="" className="token-face token-back" draggable={false} />
        </div>
      </div>
    </div>
  );
}
